/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityConfigBuilderResponse
 */
export interface OpportunityConfigBuilderResponse {
    /**
     * 
     * @type {string}
     * @memberof OpportunityConfigBuilderResponse
     */
    status: OpportunityConfigBuilderResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OpportunityConfigBuilderResponse
     */
    message?: string;
}


/**
 * @export
 */
export const OpportunityConfigBuilderResponseStatusEnum = {
    Success: 'SUCCESS',
    Failure: 'FAILURE'
} as const;
export type OpportunityConfigBuilderResponseStatusEnum = typeof OpportunityConfigBuilderResponseStatusEnum[keyof typeof OpportunityConfigBuilderResponseStatusEnum];


/**
 * Check if a given object implements the OpportunityConfigBuilderResponse interface.
 */
export function instanceOfOpportunityConfigBuilderResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function OpportunityConfigBuilderResponseFromJSON(json: any): OpportunityConfigBuilderResponse {
    return OpportunityConfigBuilderResponseFromJSONTyped(json, false);
}

export function OpportunityConfigBuilderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityConfigBuilderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function OpportunityConfigBuilderResponseToJSON(value?: OpportunityConfigBuilderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

